import React from 'react'
import { useLocation } from 'react-router-dom'
import Box from '@mui/material/Box'
const ErrorPage = React.lazy(() => import('../components/errors/ErrorPage'))

const NotFound = () => {
  const { pathname } = useLocation()
  return (
    <Box
      sx={{
        minHeight: '90vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <ErrorPage error={{ status: 404, statusText: 'Page not found' }}>
        <em>{pathname}</em> could not be found
      </ErrorPage>
    </Box>
  )
}

export default NotFound
